export default "__VITE_ASSET__BSpm$dtR__"